import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { createReportTemplate } from "../thunks/createReportTemplate";
import { IReportsState } from "../types/IReportsState";

export const addCreateReportTemplate = (builder: ActionReducerMapBuilder<IReportsState>) => {
  builder.addCase(createReportTemplate.pending, (state) => {
    state.reportsCreating = true;
  });
  builder.addCase(createReportTemplate.rejected, (state, action) => {
    state.reportsCreating = false;
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка создания шаблона! "${action.meta.arg.name}": ${action.error.message}`,
    };
    state.errors = state.errors ? [...state.errors, error] : [error];
  });
  builder.addCase(createReportTemplate.fulfilled, (state, action) => {
    if (action.payload.reportID) {
      state.updated = [
        ...state.updated,
        {
          id: action.payload.reportID,
          message: `Шаблон  "${action.meta.arg.name}" успешно создан`,
        },
      ];
    }
    state.reportsCreating = false;
  });
};
